import categorizeFeaturesHelper from "@/src-refactor/modules/shared/helpers/categorize-features.helpers";
import { FeatureResponse } from "../../../store/qrtk/services/realestate/responses/feature.response";

const featureAdapter = (data: FeatureResponse) => {
  const values = categorizeFeaturesHelper(data);
  return values;
};

export default featureAdapter;
